import React from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    title: '1. Información que recopilamos',
    intro: 'Recopilamos datos personales únicamente para operar la plataforma y ofrecer una atención segura.',
    list: [
      'Datos de registro: nombre, correo electrónico, teléfono y fecha de nacimiento.',
      'Información clínica necesaria para la atención, como historia relevante, alergias o tratamientos vigentes.',
      'Datos de uso para entender cómo interactúas con la plataforma y mejorarla.',
      'Información técnica del dispositivo: IP, navegador y sistema operativo.',
    ],
  },
  {
    title: '2. Cómo utilizamos la información',
    intro: 'Procesamos los datos para brindarte una experiencia segura y personalizada.',
    list: [
      'Gestionar reservas y coordinar citas.',
      'Enviar recordatorios y comunicaciones clave sobre tu atención.',
      'Monitorear la seguridad de la cuenta y prevenir usos indebidos.',
      'Cumplir obligaciones legales o regulatorias vigentes.',
    ],
  },
  {
    title: '3. Compartición responsable',
    intro: 'No vendemos ni comercializamos tus datos personales. Compartimos información únicamente cuando es necesario:',
    list: [
      'Profesionales que participan directamente en tu atención, bajo confidencialidad.',
      'Proveedores tercerizados que operan infraestructura o herramientas, con acuerdos de tratamiento de datos.',
      'Autoridades cuando sea exigido por ley o para proteger derechos y seguridad.',
    ],
  },
  {
    title: '4. Seguridad de la información',
    intro: 'Adoptamos medidas técnicas y organizativas para resguardar tus datos:',
    list: [
      'Cifrado de la información sensible en tránsito y almacenamiento controlado.',
      'Controles de acceso basados en roles y monitoreo de actividad.',
      'Evaluaciones periódicas y procesos de mejora continua.',
    ],
  },
  {
    title: '5. Derechos del titular',
    intro: 'Puedes ejercer tus derechos sobre la información personal que gestionamos:',
    list: [
      'Solicitar acceso, rectificación o eliminación de tu información.',
      'Oponerte al tratamiento o solicitar la portabilidad de datos.',
      'Retirar tu consentimiento cuando el procesamiento se base en él.',
    ],
    footer:
      'Utiliza nuestro formulario de contacto para gestionar cualquier solicitud relacionada con estos derechos.',
  },
  {
    title: '6. Cookies y tecnologías similares',
    intro: 'Usamos cookies necesarias para recordar tu sesión y mejorar la experiencia. Puedes desactivarlas desde tu navegador, aunque ciertas funciones podrían verse limitadas.',
  },
  {
    title: '7. Cambios en la política',
    intro: 'Actualizamos esta política cuando se incorporan nuevas funcionalidades o cambian las regulaciones aplicables. Informaremos los cambios relevantes a través de la plataforma o correo electrónico.',
  },
];

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-16 sm:py-20">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="mb-6 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.3em] text-emerald-500">
          <span>Protección de datos</span>
          <span className="text-slate-400">•</span>
          <span>IntegraMente HwH</span>
        </div>

        <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_30px_60px_rgba(15,23,42,0.08)]">
          <div className="border-b border-slate-100 bg-slate-900/95 px-8 py-10 text-white">
            <p className="text-sm font-medium uppercase tracking-[0.32em] text-slate-400">Documento oficial</p>
            <h1 className="mt-3 text-3xl font-semibold leading-tight sm:text-4xl">Política de privacidad</h1>
            <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-xs font-medium uppercase tracking-[0.25em] text-slate-200">
              Última actualización · 22 de agosto de 2024
            </p>
          </div>

          <div className="px-6 py-10 sm:px-10 sm:py-12 lg:px-14 lg:py-14">
            <p className="text-sm leading-relaxed text-slate-600">
              Esta política describe cómo IntegraMente HwH recopila, utiliza y protege los datos personales de pacientes, profesionales y otros usuarios de la plataforma.
            </p>

            <div className="mt-10 space-y-10">
              {sections.map((section) => (
                <section key={section.title} className="space-y-4">
                  <h2 className="text-lg font-semibold text-slate-900 sm:text-xl">{section.title}</h2>
                  <p className="text-sm leading-relaxed text-slate-600">{section.intro}</p>
                  {section.list && (
                    <ul className="ml-4 list-disc space-y-2 text-sm text-slate-600">
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.footer && (
                    <p className="text-sm leading-relaxed text-slate-600">
                      {section.footer}{' '}
                      <Link
                        to="/contacto"
                        className="font-semibold text-emerald-600 underline-offset-4 hover:text-emerald-700 hover:underline"
                      >
                        formulario de contacto
                      </Link>
                      .
                    </p>
                  )}
                </section>
              ))}
            </div>

            <div className="mt-12 rounded-2xl border border-slate-200 bg-emerald-50/70 px-6 py-6 text-sm text-emerald-900">
              Si necesitas más información sobre el tratamiento de datos personales, escríbenos y nuestro equipo responderá a la brevedad.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;


